import React, { useState } from "react";
import { Sparkles, X } from "lucide-react";

const DEMO_URL = "https://meetings.hubspot.com/jonfred/freddy-ai-roundrobin?uuid=133f5796-273b-430b-b866-3ebd46d92af4";

const BuiltByBadge = () => {
  const [dismissed, setDismissed] = useState(false);
  const [expanded, setExpanded] = useState(false);

  if (dismissed) return null;

  return (
    <div
      data-testid="built-by-badge"
      className="fixed bottom-5 right-5 z-50"
    >
      {expanded ? (
        <div
          className="bg-ff-surface border border-ff-border rounded-lg p-4 shadow-2xl max-w-xs animate-fade-in"
          style={{ backdropFilter: "blur(12px)" }}
        >
          <button
            onClick={() => setExpanded(false)}
            data-testid="badge-close"
            className="absolute top-2 right-2 text-ff-text-muted hover:text-ff-text transition-colors"
          >
            <X size={14} />
          </button>
          <p className="text-ff-text text-sm font-medium mb-1.5" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            Built by Freddy Media + Freddy Compute
          </p>
          <p className="text-ff-text-muted text-xs leading-relaxed mb-3">
            This entire platform was built using AI. We'd love to build something like this for you.
          </p>
          <a
            href={DEMO_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="badge-book-demo"
            className="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-semibold tracking-wide uppercase rounded-sm transition-all hover:brightness-110"
            style={{
              backgroundColor: "var(--ff-accent)",
              color: "#fff",
              fontFamily: "'Montserrat', sans-serif",
            }}
          >
            <Sparkles size={11} />
            Book a Demo
          </a>
        </div>
      ) : (
        <button
          onClick={() => setExpanded(true)}
          data-testid="badge-trigger"
          className="group flex items-center gap-2 bg-ff-surface/90 border border-ff-border hover:border-ff-accent/40 rounded-full px-3.5 py-2 shadow-lg transition-all hover:shadow-xl"
          style={{ backdropFilter: "blur(8px)" }}
        >
          <Sparkles size={13} className="text-ff-accent" />
          <span
            className="text-ff-text-muted group-hover:text-ff-text text-[11px] font-medium tracking-wide transition-colors"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            Built with AI
          </span>
        </button>
      )}
    </div>
  );
};

export default BuiltByBadge;
